(function(){
  function closeMobileMenu(){
    document.body.classList.remove('menu-open');
    document.documentElement.classList.remove('menu-open');
    document.querySelectorAll('.mobileMenu-toggle').forEach(function(btn){
      btn.classList.remove('is-open','active');
      btn.setAttribute('aria-expanded','false');
    });
  }

  function isMenuOpen(){
    return document.body.classList.contains('menu-open');
  }

  function isCloseButton(el){
    return !!(el && el.closest(
      '.halo-sidebar-close, .halo-sidebar__close, .sidebar-close, .close-sidebar, [data-close-sidebar], [data-menu-close-sidebar], [data-sidebar-close], button[aria-label="Close"], button[aria-label="Fermer"], button[aria-label="close"], button[aria-label="fermer"]'
    ));
  }

  function isInsideMobileMenu(el){
    return !!(el && el.closest('.halo-sidebar-menu'));
  }

  document.addEventListener('click', function(e){
    if (!isMenuOpen()) return;

    if (isCloseButton(e.target)) {
      e.preventDefault();
      e.stopPropagation();
      closeMobileMenu();
      return;
    }

    if (!isInsideMobileMenu(e.target) && !e.target.closest('.mobileMenu-toggle')) {
      e.preventDefault();
      closeMobileMenu();
    }
  }, true);

  document.addEventListener('touchstart', function(e){
    if (!isMenuOpen()) return;
    if (!isInsideMobileMenu(e.target) && !e.target.closest('.mobileMenu-toggle')) {
      closeMobileMenu();
    }
  }, true);

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && isMenuOpen()) closeMobileMenu();
  });
})();
